<label class="db">{{labelText}}</label>
<input [type]="inputType" pInputText
  [(ngModel)]="ngModelData"
  (ngModelChange)="ngModelDataChange.emit($event)"
  class="form-control"
  [formControl]="control"
  [placeholder]="placeholderText" />
<app-validator-error [control]="controlValidation" ></app-validator-error>
